import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import UserListItemFragment from '../fragments/UserListItemFragment';

export default gql`
query adminUserList($filters: UserFilters, $sortBy: UserSort, $count: Int!, $page: Int) {
    listAdmins(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...UserListItemFragment
        }
    }
}
${PaginatorInfoFragment}
${UserListItemFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminUserList.ts